import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { ValidateFiscalCode, ValidationResponse } from '@models/swagger';
import { ValidateFiscalCodeParams } from './service';

export enum ValidateFiscalCodeActions {
  Failure = '[Application Utilities ValidateFiscalCode] Failure',
  Request = '[Application Utilities ValidateFiscalCode] Request',
  Success = '[Application Utilities ValidateFiscalCode] Success',
}

export const ValidateFiscalCodeFailure = createAction(
  ValidateFiscalCodeActions.Failure,
  props<{ error: HttpErrorResponse }>()
);

export const ValidateFiscalCodeRequest = createAction(
  ValidateFiscalCodeActions.Request,
  props<{ body: ValidateFiscalCode; parameters?: ValidateFiscalCodeParams }>()
);

export const ValidateFiscalCodeSuccess = createAction(
  ValidateFiscalCodeActions.Success,
  props<{ data: ValidationResponse }>()
);
